(function() { window.GUID_9631d49b_e250_48f0_a3f7_4012490e2c11 = { getGuid: function() { return "9631d49b-e250-48f0-a3f7-4012490e2c11"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RangeDatePicker extends Controls.ControlBase {
            constructor(options) {
                super(options);
            }
            get ControlId() {
                return this.id;
            }
            get $Control() {
                return this.control;
            }
            get MaxDate() { return this.options.maxValue; }
            set MaxDate(date) {
                this.options.maxValue = date;
                this.To.SetMaxDate(date, true);
            }
            get MinDate() { return this.options.minValue; }
            set MinDate(date) {
                this.options.minValue = date;
                this.From.SetMinDate(date, true);
            }
            get SelectedRange() {
                return {
                    From: this.From.SelectedDate,
                    To: this.To.SelectedDate
                };
            }
            OnControlInstantiation(params) {
                this.options = params[0];
                this.control = this.options.container;
                this.From = this.options.from;
                this.To = this.options.to;
                if (this.control.attr("id"))
                    this.id = this.control.attr("id");
                else {
                    this.id = `daterange-picker-${this.From.ControlId}-${this.To.ControlId}`;
                    this.control.attr("id", this.id);
                }
                if (this.options.minValue)
                    this.From.SetMaxDate(this.options.minValue, true);
                if (this.options.maxValue)
                    this.To.SetMaxDate(this.options.maxValue, true);
                this.updateDateConstraint();
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                Controls.DatePicker.Events.DatePickerValueChanged({
                    selector: [this.From, this.To],
                    callback: (control, event) => {
                        if (me.updateDateConstraint())
                            me.raiseDateChanged(event.jqueryEventObject);
                    }
                });
            }
            raiseDateChanged(event) {
                this.Trigger(that.EventNames.ValueChanged, {
                    jqueryEventObject: event, data: this.SelectedRange
                });
            }
            updateDateConstraint() {
                var fromDate = this.From.SelectedDate;
                var toDate = this.To.SelectedDate;
                if (!this.options.disableDateConstraint) {
                    if (fromDate)
                        this.To.SetMinDate(fromDate);
                    if (toDate)
                        this.From.SetMaxDate(toDate);
                }
                return fromDate && toDate && fromDate.getTime() < toDate.getTime();
            }
        }
        Controls.RangeDatePicker = RangeDatePicker;
        (function (RangeDatePicker) {
            class Events {
                static RangeChanged(param) {
                    Controls.RegisterEvent(that, EventNames.ValueChanged, param);
                }
            }
            RangeDatePicker.Events = Events;
            class EventNames {
            }
            EventNames.ValueChanged = "range-datepicker-value-changed";
            RangeDatePicker.EventNames = EventNames;
        })(RangeDatePicker = Controls.RangeDatePicker || (Controls.RangeDatePicker = {}));
        var that = RangeDatePicker;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=range-datepicker.js.map
